import { arrayMap } from "./array.utils";

export function addressFormatter(address) {
  const isCity = !!address?.dhaka_city;
  const typeName = address?.type?.name ? address?.type?.name + "#" : "";

  const generalAddress = {
    typeName,
    street: address?.street ?? "",
    village: address?.village?.name ?? "",
    postOffice: address?.post_office?.name ?? "",
    postCode: address?.post_office?.post_code ?? "",
    union: address?.union?.name ?? "",
    upazila: address?.upazila?.name ?? "",
    district: address?.district?.name ?? "",
    division: address?.division?.name ?? ""
  };

  console.log(address);
  

  const cityAddress = {
    typeName,
    street: address?.street ?? "",
    dhakaCity: address?.dhaka_city?.name ?? "",
    dhakaCityThana: address?.dhaka_city?.dhaka_city_thana?.name ?? "",
    cityName: "",
    dhakaCityThanaPostCode: address?.dhaka_city?.dhaka_city_thana?.post_code ?? ""
  };

  return isCity ? cityAddress : generalAddress;
}

export function fullAddressView(address) {
  const fullAddress = addressFormatter(address);
  function formatAddressParts(parts) {
    return Object.values(parts)
      .filter((value) => !!value) // Filter out empty values
      .join(", ");
  }

  return formatAddressParts(fullAddress);
}

export function multiFullAddressView(addresses) {
  return arrayMap(addresses, (address) => (
    <div className={`${addresses?.length > 0 ? "mb-2" : ""}`}>{fullAddressView(address)}</div>
  ));
}

export function checkCreateOrUpadateCustomerAddressValues(obj) {
  for (let key in obj) {
    if (key !== "type_id" && obj[key] !== "") {
      return true;
    }
  }
  return false;
}
